import {useState, useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostUtilSms = (contactRef) => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [isSent, setIsSent] = useState(false)

	const clickEvent = () => {
		// Remove all spaces from phone number
		const contact = contactRef?.current?.value?.replace(/\s/g, '')
		fetchRequest('POST', '/admin/util/sms', {
			contact: contact,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setIsSent(true)
				break
			case 400:
				if (fetchResult?.data?.error_code === 'contact')
					setAlert('연락처 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [isSent, clickEvent]
}

export default usePostUtilSms
